import { z } from 'zod';
import { widgetKeysSchema } from './common';
import { jObjectLittle } from '../objectBase';

export const widgetDefinitionPropsSchema = z.object({
    label: z.string(),
    description: z.string(),
    name: widgetKeysSchema,
    img: z.string(),
    available: z.boolean(),
    displayLevel: z
        .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
        .array()
        .optional(),
    panel: z.object({
        useWrapper: z.boolean(),
        useSelection: z.boolean(),
        useEditor: z.boolean(),
        useWidgets: z.boolean(),
    }),
});
export type WidgetDefinitionProps = z.infer<typeof widgetDefinitionPropsSchema>;

export const ensureWidgetDefinitionProps = (o: unknown): o is WidgetDefinitionProps =>
    widgetDefinitionPropsSchema.safeParse(o).success;

export const ensureWidgetObjectHasMinimumProperties = (
    o: Partial<jObjectLittle> | undefined,
): o is Pick<jObjectLittle, 'id' | 'type' | 'uri'> => {
    return o !== undefined && 'id' && 'type' in o && 'uri' in o;
};
